// extracted by mini-css-extract-plugin
export default {"surferWeekPopup":"SurferWeekPopup_surferWeekPopup__5Neb7","surferImg":"SurferWeekPopup_surferImg__OrV2R"};